import { render, staticRenderFns } from "./crateForecast.vue?vue&type=template&id=3aa71e52"
import script from "./crateForecast.vue?vue&type=script&lang=js"
export * from "./crateForecast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports